import { InfoOutlineIcon } from '@chakra-ui/icons';
import {
    Box,
    Button,
    Checkbox,
    Divider,
    Flex,
    Icon,
    Image,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Radio,
    RadioGroup,
    Select,
    Spinner,
    Switch,
    Table,
    Tbody,
    Td,
    Text,
    Textarea,
    Th,
    Thead,
    Tooltip,
    Tr,
    useColorModeValue,
    useDisclosure,
    useToast
} from '@chakra-ui/react';
import BuildUrlParamsUpdate from 'components/adspresso/BuildUrlParamsUpdate';
import FaceBookPageSelector from 'components/adspresso/FaceBookPageSelector';
import InstagramAccountUpdateSelector from 'components/adspresso/InstagramAccountUpdateSelector';
import UrlParametersUpdate from 'components/adspresso/UrlParametersUpdate';
import DriveModal from 'components/drive/DriveModal';
import ReplaceDriveModal from 'components/drive/ReplaceDriveModal';
import AdPreviewCampaignSizes from 'components/genericForms/AdPreviewCampaignSizes';
import MessageTemplateModal from 'components/genericForms/MessageTemplateModal';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { FaExchangeAlt } from 'react-icons/fa';
import { MdOutlineEdit } from 'react-icons/md';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useGetAdCreativeQuery, useGetInstantFormsByPageIdQuery, useUpdateAdMutation } from 'store/campaigns/adsApi';
import { useGetAdvertisableAppsQuery } from 'store/campaigns/adsetFormApi';
import {
    call_to_action_options,
    call_to_action_options_app_promptions,
    call_to_action_options_Awareness_Traffic_Engagement,
    call_to_action_options_for_app_leads_and_sales,
    call_to_action_options_instantForms,
    call_to_action_options_whatsapp
} from 'utils/callToActions';
import { getCallToActionOptions, removeEmptyValues } from 'utils/functions';
import imagePlacementConfig from 'utils/imagePlacementConfig.json';
import videoPlacementConfig from 'utils/videoPlacementConfig.json';
import * as Yup from 'yup';

const SizeAdUpdateForm = ({ adData, adsAccountData, onClose, onSuccess }) => {

    const toast = useToast();
    const background = useColorModeValue('gray.50', 'gray.800');
    const buttonBackgroundColor = useColorModeValue('gray.50', 'gray.800');
    const backgroundColor = useColorModeValue('#F5F3F9', '#1e1530');
    const [isDriveModalOpen, setIsDriveModalOpen] = useState(false);
    const { isOpen: isEditMediaOpen, onOpen: OnEditMediaOpen, onClose: OnEditMediaClose } = useDisclosure();
    const { isOpen: isReplaceModalOpen, onOpen: OnReplaceModalOpen, onClose: OnReplaceModalClose } = useDisclosure();
    const { isOpen: isMessageModalOpen, onOpen: onMessageModalOpen, onClose: onMessageModalClose } = useDisclosure();
    const [isEnabled, setIsEnabled] = useState(true);
    const [isUrlModalOpen, setUrlModalOpen] = useState(false);
    const [activePlacement, setActivePlacement] = useState(null);
    const [isUrlParamModalOpen, setUrlParamModalOpen] = useState(false);
    const [selectedMediaUrls, setselectedMediaUrls] = useState([]);

    const { data: adCreative, isLoading } = useGetAdCreativeQuery(
        {
            creativeId: adData?.id,
            adsAccountId: adsAccountData?.account_id
        },
        { skip: !adData?.id }
    );

    const [updateAd] = useUpdateAdMutation();

    const pageId = adData?.adset?.promoted_object?.page_id;

    const formattedPageIds = Array.isArray(pageId) ? pageId : [pageId];

    const { data: instantForms } = useGetInstantFormsByPageIdQuery(
        { pageIds: formattedPageIds },
        { skip: !formattedPageIds.length || adData?.adset?.destination_type !== 'ON_AD' }
    );

    const { data: advertisableApps } = useGetAdvertisableAppsQuery({adsAccountId: adsAccountData?.account_id}, {skip: !adsAccountData?.account_id});

    let pageIdToSend = null;
    if (
        adCreative?.adset?.destination_type === "PHONE_CALL" &&
        adCreative?.adset?.promoted_object?.page_id
    ) {
        pageIdToSend = adCreative?.adset?.promoted_object?.page_id;
    } else if (
        adCreative?.campaign?.objective === "OUTCOME_AWARENESS"
    ) {
        pageIdToSend = adCreative?.adset?.promoted_object?.page_id;
    } else if (
        adCreative?.adset?.destination_type === "ON_PAGE"
    ) {
        pageIdToSend = adCreative?.adset?.promoted_object?.page_id;
    } else if (
        adCreative?.adset?.destination_type === "WHATSAPP"
    ) {
        pageIdToSend = adCreative?.adset?.promoted_object?.page_id;
    }

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Ad Name is required'),
        cpa: Yup.number()
            .typeError('must be a number')
            .positive('must be a positive number'),
        creative: Yup.object().shape({
            asset_feed_spec: Yup.object().shape({
                destinationType: Yup.string(),
                call_to_action_types: Yup.string().required('Type is required'),
                website_url: Yup.string().when('destinationType', {
                    is: (value) => !['APP', 'PHONE_CALL', 'ON_PAGE', 'WHATSAPP'].includes(value),
                    then: () => Yup.string().required('Link is required'),
                    otherwise: () => Yup.string().notRequired(),
                }),
                phoneNumber: Yup.string().
                    when('call_to_action_types', {
                        is: 'CALL_NOW',
                        then: () => Yup.string().required('Phone number is required'),
                        otherwise: () => Yup.string().notRequired(),
                    })
                    .min(10, 'Phone number is too short')
                    .max(15, 'Phone number is too long'),
                })
        })
    });

    const formik = useFormik({
        initialValues: {
            name: adData?.name || '',
            hash: adData?.hash || '',
            cpa: adData?.cpa || '',
            page_backed_insta_id: '',
            creative: {
                name: adCreative?.creative?.name || '',
                url_tags: adCreative?.creative?.url_tags || '',
                object_story_spec: {
                    page_id: adCreative?.creative?.object_story_spec?.page_id || '',
                    instagram_user_id: adCreative?.creative?.object_story_spec?.instagram_user_id || '',
                },
                contextual_multi_ads: {
                    enroll_status: adCreative?.creative?.contextual_multi_ads?.enroll_status || '',
                },
                pac_relaxation_enroll_status: adCreative?.creative?.degrees_of_freedom_spec?.creative_features_spec?.pac_relaxation?.enroll_status || 'OPT_IN',
                app_id: adCreative?.creative?.template_url_spec?.config?.app_id || '',  
                asset_feed_spec: {
                    destinationType: adCreative?.campaign?.objective === "OUTCOME_AWARENESS" ? adCreative?.campaign?.objective : adCreative?.adset?.destination_type ? adCreative?.adset?.destination_type : '',
                    ad_formats: adCreative?.creative?.asset_feed_spec?.images?.length ? 'SINGLE_IMAGE' : 'SINGLE_VIDEO',
                    media:
                        adCreative?.creative?.asset_feed_spec?.images?.length
                            ? adCreative?.creative?.asset_feed_spec?.images
                            : adCreative?.creative?.asset_feed_spec?.videos || [],
                    call_to_action_types:
                        adCreative?.creative?.asset_feed_spec?.call_to_action_types ? adCreative?.creative?.asset_feed_spec?.call_to_action_types?.[0] : '',
                    description:
                        adCreative?.creative?.asset_feed_spec?.descriptions ? adCreative?.creative?.asset_feed_spec?.descriptions[0]?.text : '',
                    deeplink_url: adCreative?.creative?.asset_feed_spec?.link_urls ? adCreative?.creative?.asset_feed_spec?.link_urls[0]?.deeplink_url : '',
                    website_url: adCreative?.creative?.asset_feed_spec?.link_urls ? adCreative?.creative?.asset_feed_spec?.link_urls[0]?.website_url : '',
                    phoneNumber:
                        adCreative?.creative.asset_feed_spec?.call_to_actions &&
                        adCreative?.creative.asset_feed_spec.call_to_actions[0]?.value?.link?.includes('tel:+')
                        ? adCreative?.creative.asset_feed_spec.call_to_actions[0].value.link.replace('tel:+', '')
                        : '',
                    caption: adCreative?.creative?.asset_feed_spec?.link_urls ? adCreative?.creative?.asset_feed_spec?.link_urls[0]?.display_url : '',
                    message:
                        adCreative?.creative?.asset_feed_spec?.bodies ? adCreative?.creative?.asset_feed_spec?.bodies[0]?.text : '',
                    name:
                        adCreative?.creative?.asset_feed_spec?.titles ? adCreative?.creative?.asset_feed_spec?.titles[0]?.text : '',
                    app_product_page_id:
                        adCreative?.creative?.asset_feed_spec?.app_product_page_id || '',
                    additional_data : {
                        page_welcome_message: (() => {
                            const raw = adCreative?.creative?.asset_feed_spec?.additional_data?.page_welcome_message;
                              return typeof raw === 'string' ? JSON.parse(raw) : raw;
                        })() 
                    }
                },
            },
            image_url: adCreative?.creative?.thumbnail_url || '',
        },
        validationSchema,
        enableReinitialize: true,
        validateOnMount: false,
        onSubmit: (values, { setSubmitting }) => {

            const formatPhoneNumber = (phoneNumber) => {

                if (!phoneNumber.startsWith('tel:+')) {
                    return `tel:+${phoneNumber}`;
                }
                return phoneNumber;
            };

            const storySpec = {
                page_id: values.creative.object_story_spec.page_id,
                instagram_user_id: values.creative.object_story_spec.instagram_user_id
            };

            // Step 1: Create a hash -> { mediaType, placement } map
            const hashMap = {};
            selectedMediaUrls?.forEach(item => {
                hashMap[item.hash] = {
                    mediaType: item.mediaType,
                    placement: item.placement
                };
            });

            // Step 2: Deduplicate mediaData based on hash
            const seenHashes = new Set();
            const hashDuplicates = new Map();

            // First pass: gather duplicates by hash
            selectedMediaUrls?.forEach(item => {
                if (seenHashes.has(item.hash)) {
                    if (!hashDuplicates.has(item.hash)) {
                        hashDuplicates.set(item.hash, []);
                    }
                    hashDuplicates.get(item.hash).push(item.placement);
                } else {
                    seenHashes.add(item.hash);
                }
            });

            // Reset seenHashes to reuse it
            seenHashes.clear();

            // Second pass: build mediaData with tags
            const mediaData = selectedMediaUrls?.filter(item => {
                if (seenHashes.has(item.hash)) return false;
                seenHashes.add(item.hash);
                return true;
            })
                .map(item => {
                    const duplicatePlacements = hashDuplicates.get(item.hash);
                    const tag = duplicatePlacements?.length
                        ? { duplicatePlacements }
                        : undefined;

                    return {
                        [item.mediaType === 'image' ? 'hash' : 'video_id']: item.hash,
                        [item.mediaType === 'image' ? 'creative_hash' : 'hash']: item.mediaHash,
                        mediaType: item.mediaType,
                        adlabels: [{ name: item.placement }],
                        ...(tag && { tag })
                    };
                });

            // Remove 'tag' before assigning
            const cleanedMediaData = mediaData?.map(({ tag, mediaType, ...rest }) => rest);

            // Step 3: Build asset_customization_rules using hashMap
            const asset_customization_rules = [];

            mediaData?.forEach(media => {
                const meta = hashMap[media.mediaType === 'image' ? media.hash : media.video_id];
                if (!meta) return; // safety check

                const { mediaType } = meta;
                const isDuplicate = media.tag?.duplicatePlacements?.length > 0;

                (media?.adlabels || []).forEach(label => {
                    const placement = label.name;
                    if (!placement) return;

                    asset_customization_rules?.push({
                        [mediaType === 'image' ? 'image_label' : 'video_label']: { name: placement },
                        customization_spec: isDuplicate
                            ? {}
                            : (mediaType === 'image' ? imagePlacementConfig : videoPlacementConfig)[placement] || {}
                    });
                });
            });

            const titles = values.creative.asset_feed_spec.name
                ? [{ text: values.creative.asset_feed_spec.name }]
                : undefined;

            const bodies = values.creative.asset_feed_spec.message
                ? [{ text: values.creative.asset_feed_spec.message }]
                : undefined;

            const descriptions = values.creative.asset_feed_spec.description
                ? [{ text: values.creative.asset_feed_spec.description }]
                : undefined;

            const call_to_action_types = [values.creative.asset_feed_spec.call_to_action_types];
            const call_to_actions = [
                ...(adCreative?.adset?.destination_type === 'PHONE_CALL' ? [{
                  type: values.creative.asset_feed_spec.call_to_action_types,
                  value: {
                    link: formatPhoneNumber(values.creative.asset_feed_spec.phoneNumber)
                  }
                }] : []),
              
                ...(adCreative?.adset?.destination_type === 'ON_AD' ? [{
                  type: values.creative.asset_feed_spec.call_to_action_types,
                  value: {
                    lead_gen_form_id: values.creative.asset_feed_spec.website_url
                  }
                }] : []),

                ...(adCreative?.adset?.destination_type === 'WHATSAPP' ? [{
                    type: values.creative.asset_feed_spec.call_to_action_types,
                    value: {
                      app_destination : "WHATSAPP"
                    }
                }] : [])
              ];

            const websiteUrl = adCreative?.adset?.destination_type === 'PHONE_CALL'
                                ? `https://facebook.com/${values.creative.object_story_spec.page_id || ''}/`
                                : adCreative?.adset?.destination_type === 'ON_AD'
                                ? 'http://fb.me/'
                                : adCreative?.adset?.destination_type === 'WHATSAPP'
                                    ? "https://api.whatsapp.com/send"
                                : adCreative?.adset?.destination_type === 'APP'
                                    ? values.creative.asset_feed_spec.website_url
                                    : values.creative.asset_feed_spec.website_url || '';

            const link_urls = [
                {
                    website_url: websiteUrl,
                    ...(adCreative?.adset?.destination_type === 'APP' && { deeplink_url: values.creative.asset_feed_spec.deeplink_url }),
                    ...(!['CALL_NOW','LIKE_PAGE'].includes(values.creative.asset_feed_spec.call_to_action_types) && {display_url: values.creative.asset_feed_spec.caption})
                }
            ];

            const app_product_page_id = values.creative.asset_feed_spec.app_product_page_id;
            const contextual_multi_ads = {
                enroll_status: values.creative.contextual_multi_ads.enroll_status,
            };
            const shouldIncludeDegreesOfFreedom =
                    ["OUTCOME_AWARENESS", "OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT", "OUTCOME_SALES", "OUTCOME_LEADS"]
                        .includes(adCreative?.campaign?.objective) &&
                    values.creative.asset_feed_spec.call_to_action_types !== 'LIKE_PAGE' &&
                    adCreative?.adset?.destination_type !== 'WEBSITE_AND_PHONE_CALL';

            const degreesOfFreedomSpec = shouldIncludeDegreesOfFreedom
                    ? {
                        degrees_of_freedom_spec: {
                            creative_features_spec: {
                            pac_relaxation: {
                                enroll_status: values?.creative?.pac_relaxation_enroll_status,
                            },
                            },
                        },
                        }
                    : {};


            let creativePayload = {};

            creativePayload = values?.creative?.asset_feed_spec?.ad_formats === 'SINGLE_VIDEO' ?
                {
                    creative: {
                        object_type: "SHARE",
                        object_story_spec: storySpec,
                        contextual_multi_ads,
                        ...(values.creative?.url_tags?.trim() && { url_tags: values.creative.url_tags }),
                        asset_feed_spec: {
                            ad_formats: [
                                "SINGLE_VIDEO"
                            ],
                            videos: cleanedMediaData,
                            asset_customization_rules: asset_customization_rules,
                            call_to_action_types,
                            call_to_actions,
                            link_urls,
                            app_product_page_id,
                            optimization_type: "PLACEMENT",
                            ...(titles && { titles }),
                            ...(bodies && { bodies }),
                            ...(descriptions && { descriptions }),
                            ...((['WHATSAPP'].includes(adCreative?.adset?.destination_type)) && {
                                additional_data:{
                                    page_welcome_message: values?.creative?.asset_feed_spec?.additional_data?.page_welcome_message
                                }
                            }),
                        }, 
                        ...((adCreative?.campaign?.objective === "OUTCOME_AWARENESS" || adCreative?.adset?.destination_type === 'ON_VIDEO')  && {
                            template_url_spec: {
                                config: {
                                    app_id: values.creative.app_id,
                                }
                            }
                        }),
                        ...degreesOfFreedomSpec,
                    }
                } : {
                    creative: {
                        object_type: "VIDEO",
                        object_story_spec: storySpec,
                        contextual_multi_ads,
                        ...(values.creative?.url_tags?.trim() && { url_tags: values.creative.url_tags }),
                        asset_feed_spec: {
                            ad_formats: [
                                "SINGLE_IMAGE"
                            ],
                            images: cleanedMediaData,
                            asset_customization_rules: asset_customization_rules,
                            call_to_action_types,
                            call_to_actions,
                            link_urls,
                            app_product_page_id,
                            optimization_type: "PLACEMENT",
                            ...(titles && { titles }),
                            ...(bodies && { bodies }),
                            ...(descriptions && { descriptions }),
                            ...((['WHATSAPP'].includes(adCreative?.adset?.destination_type)) && {
                                additional_data:{
                                    page_welcome_message: values?.creative?.asset_feed_spec?.additional_data?.page_welcome_message
                                }
                            }),
                        },
                        ...(adCreative?.campaign?.objective === "OUTCOME_AWARENESS" && {
                            template_url_spec: {
                                config: {
                                    app_id: values.creative.app_id,
                                }
                            }
                        }),
                        ...degreesOfFreedomSpec,
                    }
                }

            const initialPayload = {
                ...creativePayload,
                ...(values.name !== adData.name ? { name: values.name } : {}), // Include name only if it has changed
                ...(values.cpa && values.cpa !== '' && values.cpa !== adData.cpa ? { cpa: values.cpa } : {}),
                objective: adCreative?.campaign?.objective,
                destination_type: adCreative?.adset?.destination_type,
                adsAccount: {
                    id: adsAccountData?.id,
                    adsAccountId: adsAccountData?.account_id,
                    adsAccountName: adsAccountData?.name,
                    businessName: adsAccountData?.business?.name,
                    businessId: adsAccountData?.business?.id,
                },
            };

            const payload = removeEmptyValues(initialPayload);

            updateAd({ creativeId: adData.id, payload })
                .unwrap()
                .then(response => {
                    onSuccess();
                    toast({
                        position: "top-right",
                        title: "Ad updated",
                        status: "success",
                        duration: 4000,
                        isClosable: true,
                    });
                })
                .catch(error => {
                    toast({
                        position: "top-right",
                        title: "Error updating ad",
                        description: error?.data?.message,
                        status: "error",
                        duration: 4000,
                        isClosable: true,
                    });
                })
                .finally(() => {
                    setSubmitting(false);
                    onClose();
                });
        },
    });

    useEffect(() => {
        const assetFeed = adCreative?.creative?.asset_feed_spec;
        if (!assetFeed) return;

        const isVideo = assetFeed?.ad_formats?.[0] === 'SINGLE_VIDEO';
        const media = isVideo ? assetFeed.videos || [] : assetFeed.images || [];
        const customizationRules = assetFeed.asset_customization_rules || [];

        // Step 1: Build a map of media data by label
        const mediaMap = {};
        media.forEach((file) => {
            const label = file?.adlabels?.[0]?.name;
            if (label) {
                mediaMap[label] = {
                    placement: label,
                    url: file?.thumbnail_url,
                    mediaType: isVideo ? 'video' : 'image',
                    hash: isVideo ? file?.video_id : file?.hash,
                };
            }
        });

        // Step 2: Find fallback label from customization_rules with empty customization_spec
        const fallbackLabel = customizationRules.find(rule => {
            const spec = rule?.customization_spec;

            // Case 1: customization_spec is missing
            if (!spec) return true;

            const keys = Object.keys(spec).sort();

            // Case 2: customization_spec is empty
            if (keys.length === 0) return true;

            // Case 3: customization_spec has only age_min and age_max
            return keys.length === 2 && keys.includes('age_min') && keys.includes('age_max');
        })?.[isVideo ? 'video_label' : 'image_label']?.name;

        const fallbackMedia = mediaMap[fallbackLabel];

        // Step 3: Ensure all 3 placements
        const requiredPlacements = ['square', 'vertical', 'horizontal'];
        const finalMedia = requiredPlacements.map((label) => {
            if (mediaMap[label]) {
                return mediaMap[label];
            } else if (fallbackMedia) {
                return {
                    ...fallbackMedia,
                    placement: label,
                };
            } else {
                return null;
            }
        }).filter(Boolean); // Remove nulls

        setselectedMediaUrls(finalMedia);
    }, [adCreative?.creative]);

    useEffect(() => {
        if (selectedMediaUrls.length > 0) {
            formik.setFieldValue('mediaUrls', selectedMediaUrls);
        }
    }, [selectedMediaUrls])

    const handleReplaceImage = (placement, type) => {
        setActivePlacement(placement);
        OnReplaceModalOpen();
        formik.setFieldValue('creative?.asset_feed_spec?.ad_formats', type);
    };

    const handleImageSelectedFromReplaceDrive = (file) => {
        if (file && file.length > 0) {

            const newImageUrl = file[0];

            setselectedMediaUrls((prev) =>
                prev.map((item) =>
                    item.placement === activePlacement
                        ? {
                            ...item,
                            url: newImageUrl?.url ? newImageUrl?.url : newImageUrl?.picture,
                            hash: newImageUrl?.creativeId,
                            mediaHash: newImageUrl?.hash,
                            source: newImageUrl?.source,
                        }
                        : item
                )
            );
        }

        setActivePlacement(null);
        OnReplaceModalClose();
    };


    const handleOpenDriveModal = () => {
        setIsDriveModalOpen(true);
    };

    const handleMediaSelect = (file) => {
        if (file && file.length > 0) {
            const selectedFile = file[0];

            const placements = ['square', 'vertical', 'horizontal'];

            const fileData = placements?.map((placement) => ({
                placement,
                url: selectedFile?.url ? selectedFile?.url : selectedFile?.picture,
                source: selectedFile?.source,
                mediaType: selectedFile?.url ? 'image' : 'video',
                hash: selectedFile?.creativeId,
                mediaHash: selectedFile?.hash,
            }));

            setselectedMediaUrls(fileData);

            formik.setFieldValue('hash', selectedFile?.hash);
            formik.setFieldValue('image_url', selectedFile?.url);
            formik.setFieldValue('creative.object_story_spec.link_data.image_hash', selectedFile?.creativeId);
        }
        setIsDriveModalOpen(false);
    };

    if (isLoading) {
        return <Flex justify="center" align="center" height="60vh">
            <Spinner size="md" />
        </Flex>
    }

    const handleUrlChange = (constructedUrl) => {
        formik.setFieldValue('creative.object_story_spec.link_data.link', constructedUrl);
    };

    const handleUrlParamChange = (constructedUrl) => {
        formik.setFieldValue('creative.url_tags', constructedUrl);
    };

    const filteredInstantForms = instantForms?.length > 0 && instantForms
        .map((formResponse) => formResponse?.data?.data) // Get the 'data' array from each formResponse
        .flat() // Flatten the array to get all forms in one array
        .filter((form) => form?.page_id === pageId);

    // console.log(formik.values)
    // console.log(formik.errors)

    return (
        <form onSubmit={formik.handleSubmit}>
            <Flex gap={4}>
                <Box direction={'column'} gap={4} width="100%" flex={0.4}>
                    <Flex direction={'column'} gap={'20px'} borderRadius="md" bg={background} p={4} mb={4}>
                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">Ad Name</Text>
                            <Input
                                name="name"
                                placeholder="Enter your ad name here..."
                                bg="#fff"
                                size='sm'
                                borderRadius="md"
                                value={formik.values.name}
                                onChange={formik.handleChange}
                            />
                            {formik.errors.name && (
                                <Text fontSize={"12px"} color="red.500">{formik.errors.name}</Text>
                            )}
                        </Flex>

                        <Flex direction="column" gap={1} mb={2}>
                            <Text fontWeight="bold">Facebook Page</Text>
                            <FaceBookPageSelector
                                adsAccount={adsAccountData}
                                selectedPageId={formik?.values?.creative?.object_story_spec?.page_id}
                                pageIdToSend={pageIdToSend}
                                onSelectedPage={(pageId) => {
                                    formik.setFieldValue('creative.object_story_spec.page_id', pageId);

                                    // Reset the Instagram actor ID to an empty string
                                    formik.setFieldValue('creative.object_story_spec.instagram_user_id', '');
                                }}
                            />
                            {formik.touched.creative?.object_story_spec?.page_id && formik.errors.creative?.object_story_spec?.page_id && (
                                <Text fontSize={"12px"} color="red.500">{formik.errors.creative?.object_story_spec?.page_id}</Text>
                            )}
                        </Flex>

                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">Instagram accounts</Text>
                            <InstagramAccountUpdateSelector
                                pageID={formik?.values?.creative?.object_story_spec?.page_id}
                                adsAccount={adsAccountData}
                                selectedInstPageId={formik?.values?.creative?.object_story_spec?.instagram_user_id}
                                onSelectedPage={(pageId) => {
                                    formik.setFieldValue('creative.object_story_spec.instagram_user_id', pageId);
                                }}
                                onPageBack={(pageId) => {
                                    formik.setFieldValue('page_backed_insta_id', pageId);
                                }}
                            />
                            {formik.errors.creative?.object_story_spec?.instagram_user_id && (
                                <Text fontSize={"12px"} color="red.500">{formik.errors.creative?.object_story_spec?.instagram_user_id}</Text>
                            )}
                        </Flex>
                    </Flex>
                    <Flex direction={'column'} gap={'20px'} borderRadius="md" bg={background} p={4} mb={4}>

                        <Flex gap={2} alignItems={'center'} justifyContent={'flex-start'}>
                            <Flex direction={'column'} gap={2}>
                                <Text fontWeight="bold">Ad creative</Text>
                                {selectedMediaUrls && selectedMediaUrls[0]?.url && (
                                    <Flex gap={2}>
                                        <Image
                                            src={(selectedMediaUrls[0]?.url)}
                                            alt={"adcreative-img"}
                                            objectFit="cover"
                                            width="80px"
                                            height="80px"
                                            borderRadius="3px"
                                        />

                                        <Flex align={'center'} justifyContent={'center'} direction={'column'} gap={2}>
                                            <Flex gap={2}>
                                                <Tooltip label="Edit Media" fontSize="xs">
                                                    <Flex
                                                        p={2}
                                                        border="1px solid"
                                                        borderColor="gray.300"
                                                        borderRadius="md"
                                                        alignItems={'center'}
                                                        _hover={{ bg: 'gray.100' }}
                                                    >
                                                        <Icon
                                                            as={MdOutlineEdit}
                                                            cursor="pointer"
                                                            fontSize="18px"
                                                            onClick={OnEditMediaOpen}
                                                        />
                                                    </Flex>
                                                </Tooltip>
                                            </Flex>
                                            <Flex>
                                                <Button
                                                    bg={buttonBackgroundColor}
                                                    size="xs"
                                                    borderWidth={1}
                                                    onClick={handleOpenDriveModal}>
                                                    {formik?.values?.creative?.asset_feed_spec?.ad_formats === 'SINGLE_VIDEO' ? `Change Video` : `Change Image`}
                                                </Button>
                                            </Flex>
                                        </Flex>
                                    </Flex>
                                )
                                }
                            </Flex>
                        </Flex>

                        {/* Multi-advertiser ads Section */}
                        <Flex direction="column" borderRadius="md" gap={2}>
                            <Checkbox
                                onChange={(e) => {
                                    formik.setFieldValue("creative.contextual_multi_ads.enroll_status", e.target.checked ? 'OPT_IN' : 'OPT_OUT');
                                }}
                                colorScheme="brand"
                                isChecked={formik?.values?.creative?.contextual_multi_ads?.enroll_status === 'OPT_IN'}
                            >
                                <Flex align={'center'}>
                                    <Text fontWeight="bold" fontSize={'14px'}>Multi-advertiser ads &nbsp;</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p="5px">
                                                <Text>Your ads can appear alongside other ads in the same ad unit to help people discover products and services from businesses that are personalized to them. Your ad creative may be resized or cropped to fit the ad unit.</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                            </Checkbox>
                        </Flex>

                        {["OUTCOME_AWARENESS", "OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT", "OUTCOME_SALES"].includes(adCreative?.campaign?.objective) && !['ON_PAGE','WEBSITE_AND_PHONE_CALL'].includes(adCreative?.adset?.destination_type) ?
                            <Flex direction={'column'} gap={2} mb={2}>
                                <Flex alignItems="center">
                                    <Text fontWeight="bold" mr={2}>Flexible media</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Flex direction={'column'} fontSize="12px" p="5px" gap={2}>
                                                <Text fontWeight={'bold'}>Flexible media</Text>
                                                <Text>Show media that you chose for a specific aspect ratio across all placements when it's likely to improve performance. You can turn off flexible media at any time in ad creative.</Text>
                                                <Text>To preview flexible media, select a specific placement group at the top of Ad preview.</Text>
                                            </Flex>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                                <Flex alignItems={'center'} gap={2}>
                                    <Switch colorScheme='brand' size={'sm'} isChecked={formik.values.creative.pac_relaxation_enroll_status === 'OPT_IN'} onChange={(e) => formik.setFieldValue('creative.pac_relaxation_enroll_status', e.target.checked ? 'OPT_IN' : 'OPT_OUT')} />
                                    <Text fontSize="12px">We'll deliver your media selections across your placements when it's likely to improve performance.</Text>
                                </Flex>
                            </Flex>
                        :null}

                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">Primary Text</Text>
                            <Textarea
                                name="creative.asset_feed_spec.message"
                                placeholder="Message"
                                bg="#fff"
                                size='sm'
                                borderRadius="md"
                                value={formik?.values?.creative?.asset_feed_spec?.message}
                                onChange={formik.handleChange}
                            />
                        </Flex>

                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">Headline</Text>
                            <Input
                                name="creative.asset_feed_spec.name"
                                placeholder="Enter a headline"
                                bg="#fff"
                                size='sm'
                                borderRadius="md"
                                value={formik?.values?.creative?.asset_feed_spec?.name}
                                onChange={formik.handleChange}
                            />
                        </Flex>

                        {['APP','ON_PAGE'].includes(adCreative?.adset?.destination_type) ? null :
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold" >Description</Text>
                                <Textarea
                                    name="creative.asset_feed_spec.description"
                                    placeholder="Include additional details"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={formik.values.creative.asset_feed_spec.description}
                                    onChange={formik.handleChange}
                                />
                            </Flex>
                        }

                        {adCreative?.adset?.destination_type === 'ON_PAGE' ? null :
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Call to Action</Text>

                                {adCreative?.adset?.destination_type === 'PHONE_CALL' ? (
                                    <Select
                                        name="creative.asset_feed_spec.call_to_action_types"
                                        bg="#fff"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik?.values?.creative?.asset_feed_spec?.call_to_action_types}
                                        isDisabled
                                    >
                                        <option value="CALL_NOW">Call Now</option>
                                    </Select>
                                ) : adCreative?.adset?.destination_type === 'ON_AD' ? (
                                    <Select
                                        name="creative.asset_feed_spec.call_to_action_types"
                                        bg="#fff"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik?.values?.creative?.asset_feed_spec?.call_to_action_types}
                                    >
                                        {getCallToActionOptions(
                                            call_to_action_options_instantForms,
                                            formik?.values?.creative?.asset_feed_spec?.call_to_action_types
                                        ).map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) : adCreative?.adset?.destination_type === 'WHATSAPP' ? (
                                    <Select
                                        name="creative.asset_feed_spec.call_to_action_types"
                                        bg="#fff"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik?.values?.creative?.asset_feed_spec?.call_to_action_types}
                                        isDisabled={adCreative?.campaign?.objective === 'OUTCOME_LEADS'}
                                    >
                                        {getCallToActionOptions(
                                            call_to_action_options_whatsapp,
                                            formik?.values?.creative?.asset_feed_spec?.call_to_action_types
                                        ).map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) : adCreative?.adset?.destination_type === 'APP' && adData?.campaign?.objective === 'OUTCOME_APP_PROMOTION' ? (
                                    <Select
                                        name="creative.asset_feed_spec.call_to_action_types"
                                        bg="#fff"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik?.values?.creative?.asset_feed_spec?.call_to_action_types}
                                    >
                                        {getCallToActionOptions(
                                            call_to_action_options_app_promptions,
                                            formik?.values?.creative?.asset_feed_spec?.call_to_action_types
                                        ).map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) : adCreative?.adset?.destination_type === 'APP' && ["OUTCOME_SALES", "OUTCOME_LEADS"].includes(adCreative?.campaign?.objective) ? (
                                    <Select
                                        name="creative.asset_feed_spec.call_to_action_types"
                                        bg="#fff"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik?.values?.creative?.asset_feed_spec?.call_to_action_types}
                                    >
                                        {getCallToActionOptions(
                                            call_to_action_options_for_app_leads_and_sales,
                                            formik?.values?.creative?.asset_feed_spec?.call_to_action_types
                                        ).map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) : adCreative?.campaign?.objective === "OUTCOME_AWARENESS" ||  (["OUTCOME_TRAFFIC","OUTCOME_ENGAGEMENT"].includes(adCreative?.campaign?.objective) && adCreative?.adset?.destination_type === 'WEBSITE') || adCreative?.adset?.destination_type === 'ON_VIDEO'  ? (
                                    <Select
                                        name="creative.asset_feed_spec.call_to_action_types"
                                        bg="#fff"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik?.values?.creative?.asset_feed_spec?.call_to_action_types}
                                    >
                                        {getCallToActionOptions(
                                            call_to_action_options_Awareness_Traffic_Engagement,
                                            formik?.values?.creative?.asset_feed_spec?.call_to_action_types
                                        ).map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) : (
                                    <Select
                                        name="creative.asset_feed_spec.call_to_action_types"
                                        bg="#fff"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik?.values?.creative?.asset_feed_spec?.call_to_action_types}
                                    >
                                        {getCallToActionOptions(
                                            call_to_action_options,
                                            formik?.values?.creative?.asset_feed_spec?.call_to_action_types
                                        ).map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                )}
                            </Flex>
                        }

                        {adCreative?.adset?.destination_type === 'PHONE_CALL' ? (
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold" >Phone Number</Text>
                                <PhoneInput
                                    name="creative.asset_feed_spec.phoneNumber"
                                    value={formik.values.creative.asset_feed_spec.phoneNumber}
                                    onChange={(value) => formik.setFieldValue('creative.asset_feed_spec.phoneNumber', value)}
                                    country={'in'}
                                />
                                {formik.errors.creative?.asset_feed_spec?.phoneNumber && (
                                    <Text fontSize="12px" color="red.500">{formik.errors.creative.asset_feed_spec.phoneNumber}</Text>
                                )}
                            </Flex>
                        ) : null}

                        {['WEBSITE', 'ON_VIDEO'].includes(adCreative?.adset?.destination_type) || adCreative?.campaign?.objective === "OUTCOME_AWARENESS" ? (
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold" >Website URL</Text>
                                <Input
                                    name="creative.asset_feed_spec.website_url"
                                    placeholder="Enter a URL"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={formik.values.creative.asset_feed_spec.website_url}
                                    onChange={formik.handleChange}
                                />
                                <Flex mt={2}>
                                    <Button onClick={() => {
                                        setUrlModalOpen(true)
                                    }}
                                        variant="link"
                                        color='brand'>
                                        <Text fontSize={'12px'} >{'Build a URL parameter'}</Text>
                                    </Button>
                                </Flex>
                                {formik.errors?.creative?.asset_feed_spec?.website_url && (
                                    <Text fontSize={"12px"} color="red.500">{formik.errors?.creative?.asset_feed_spec?.website_url}</Text>
                                )}
                            </Flex>
                        ) : (null)} 

                        {['WHATSAPP'].includes(adCreative?.adset?.destination_type) ? (
                            <>
                                <Flex>
                                    <Text fontWeight={'bold'} fontSize={'sm'}>Message template</Text>
                                </Flex>
                            
                                {(() => {
                                const welcomeData = formik?.values?.creative?.asset_feed_spec?.additional_data?.page_welcome_message;
                                    
                                const type = welcomeData?.text_format?.customer_action_type;

                                const greeting = welcomeData?.text_format?.message?.text || '';
                                const autofillMessage = welcomeData?.text_format?.message?.autofill_message?.content || '';
                                const iceBreakers = welcomeData?.text_format?.message?.ice_breakers || [];

                                return (
                                    <Box mb={2}>
                                        <Box border={'1px solid'} borderColor={'gray.200'} p={2} borderRadius={'md'} bg={backgroundColor}>
                                            <Text fontSize={'14px'}><strong>Greeting:</strong> {greeting}</Text>

                                            {type === 'autofill_message' && (
                                                <Text fontSize={'14px'}><strong>Pre-filled message:</strong> {autofillMessage}</Text>
                                            )}

                                            {type === 'ice_breakers' && (
                                                <>
                                                <Text fontSize={'14px'}><strong>Frequently asked questions</strong></Text>
                                                {iceBreakers.map((q, i) => (
                                                    <Text key={i} fontSize="14px">
                                                    {i + 1}. {q.title}
                                                    </Text>
                                                ))}
                                                </>
                                            )}
                                        </Box>

                                        <Button
                                            variant="outline"
                                            backgroundColor="transparent" 
                                            size={'sm'}
                                            leftIcon={<MdOutlineEdit />}
                                            mt={2}
                                            onClick={() => {
                                                onMessageModalOpen();
                                            }}
                                        >
                                            Edit
                                        </Button>
                                    </Box>
                                );
                                })()}
                            </>
                        ) : null}

                        {adCreative?.adset?.destination_type === 'APP' && adData?.campaign?.objective === 'OUTCOME_APP_PROMOTION'  ? (
                            <>
                                <Flex direction="column" gap={1}>
                                    <Flex alignItems="center" gap={2}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Deferred deep link</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="sm" p="5px">
                                                    <Text fontWeight={'bold'}>Using a deferred deep link</Text><br></br>
                                                    <Text mb={2}>A deferred deep link is a URL that sends people to your app in the respective app store. Once people install your app, the link will take them to a specific screen, such as a product page.</Text>
                                                    <Text mb={2}>To use a deferred deep link, you need to first connect the Facebook SDK. You can use any of these link types:</Text>
                                                    <Box>
                                                        <Text>* Android app link</Text>
                                                        <Text>* Custom URL scheme</Text>
                                                        <Text>* Facebook app link</Text>
                                                    </Box>
                                                </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                    <Input
                                        name="creative.asset_feed_spec.deeplink_url"
                                        placeholder="Enter a deferred deep link URL"
                                        bg="#fff"
                                        size='sm'
                                        borderRadius="md"
                                        value={formik.values.creative.asset_feed_spec.deeplink_url}
                                        onChange={formik.handleChange}
                                    />
                                </Flex>

                                <Flex direction="column" gap={1}>
                                    <Flex alignItems="center" gap={2}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Custom store listing</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="sm" p="5px">
                                                    <Text fontWeight={'bold'}>Using a custom store listing</Text><br></br>
                                                    <Text mb={2}>A custom store listing ID sends people who click your ad to a landing page that you've customised in the Google Play Store.</Text>
                                                    <Text mb={2}>Use this feature to create multiple custom product pages with different media and text that speak to your various audiences.</Text>
                                                </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                    <Input
                                        name="creative.asset_feed_spec.app_product_page_id"
                                        placeholder="Enter custome store listing ID"
                                        bg="#fff"
                                        size='sm'
                                        borderRadius="md"
                                        value={formik.values.creative.asset_feed_spec.app_product_page_id}
                                        onChange={formik.handleChange}
                                    />
                                </Flex>
                            </>
                        ) : (null)}

                        {adCreative?.adset?.destination_type === 'APP' && ["OUTCOME_SALES", "OUTCOME_LEADS"].includes(adCreative?.campaign?.objective) ? (
                            <>
                                <Flex direction="column" gap={1}>
                                    <Flex alignItems="center" gap={2}>
                                        <Text fontWeight="bold">Deep link</Text>
                                        <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="sm" p="5px">
                                                   <Text>Send people to a specific place in your app. You can use an Apple universal link, Android App Link, custom URL scheme or Facebook App Link.</Text>
                                                </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                    <Input
                                        name="creative.asset_feed_spec.deeplink_url"
                                        placeholder="Enter the deep link URL"
                                        bg="#fff"
                                        size='sm'
                                        borderRadius="md"
                                        value={formik.values.creative.asset_feed_spec.deeplink_url}
                                        onChange={formik.handleChange}
                                    />
                                </Flex>
                            </>
                        ) : (null)}

                        {adCreative?.adset?.destination_type === 'ON_AD' && adData?.campaign?.objective === 'OUTCOME_LEADS' ? (
                            <>
                                <Flex alignItems="center" gap={2} mt={2}>
                                    <Text fontWeight="bold">Instant form</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="12px" p="5px">
                                                <Text>Make connections with people by letting them send contact information and other details to you through a form.</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>

                                {/* Table Layout */}
                                {filteredInstantForms?.length > 0 ? (
                                    <RadioGroup onChange={(value) => formik.setFieldValue('creative.asset_feed_spec.website_url', value)} value={formik.values.creative.asset_feed_spec.website_url} colorScheme="brand">
                                        <Table variant="simple">
                                            <Thead>
                                                <Tr>
                                                    <Th textTransform={'none'} color={'none'} fontSize="14px">Form title</Th>
                                                    <Th textTransform={'none'} color={'none'} fontSize="14px">Creation date</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {filteredInstantForms?.map((form) => (
                                                    <Tr key={form?.id} _hover={{ backgroundColor: '#F9F9F9' }} >
                                                        <Td>
                                                            <Flex alignItems="center" gap={2}>
                                                                <Radio value={form?.id} />
                                                                <Text color={form.status === 'DRAFT' ? "gray.500" : "black"} fontSize={'12px'}>
                                                                    {form?.name}
                                                                </Text>
                                                            </Flex>
                                                        </Td>
                                                        <Td>
                                                            <Text fontSize={'12px'}>
                                                                {new Date(form?.created_time).getFullYear()}-
                                                                {String(new Date(form?.created_time).getMonth() + 1).padStart(2, '0')}-
                                                                {String(new Date(form?.created_time).getDate()).padStart(2, '0')}
                                                            </Text>
                                                        </Td>
                                                    </Tr>
                                                ))}
                                            </Tbody>
                                        </Table>
                                    </RadioGroup>
                                ) : (
                                    <Text fontSize="14px" color="gray.500">No form data available</Text>
                                )}
                            </>
                        ) : null}

                        {(["OUTCOME_AWARENESS", "OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT", "OUTCOME_SALES", "OUTCOME_LEADS"].includes(adCreative?.campaign?.objective) && !['PHONE_CALL', 'ON_PAGE', 'WHATSAPP', 'ON_AD'].includes(adCreative?.adset?.destination_type))  ?  
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold" >Display link</Text>
                                <Input
                                    name="creative.asset_feed_spec.caption"
                                    placeholder="Enter the link that you want to show on your ad"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={formik.values.creative.asset_feed_spec.caption}
                                    onChange={formik.handleChange}
                                />
                            </Flex>
                        :null}

                        {adCreative?.campaign?.objective === "OUTCOME_AWARENESS" || adCreative?.adset?.destination_type === 'ON_VIDEO'  ?
                            <Flex direction={'column'} gap={1}>
                                <Flex alignItems="center" gap={2}>
                                    <Text fontWeight="bold" >Mobile app</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p="5px">
                                                <Text>Only select a mobile app if you are using a universal link (iOS or Android app link).</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                                <Select
                                    name={`creative.app_id`}
                                    bg="#fff"
                                    size="sm"
                                    borderRadius="md"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik?.values?.creative?.app_id}
                                >
                                    <option value="">Choose app</option>
                                    {advertisableApps?.map((option) => (
                                    <option key={option.id} value={option.id}>
                                        {option.name}
                                    </option>
                                ))}
                                </Select>
                            </Flex>
                        : null}

                    </Flex>

                    {['APP', 'PHONE_CALL', 'ON_PAGE', 'WHATSAPP'].includes(adCreative?.adset?.destination_type) ? null :
                        <Flex direction={'column'} gap={2} borderRadius="md" bg={background} p={4} mb={4}>
                            <Text fontWeight={'bold'}>Tracking</Text>
                            <Flex direction="column" gap={1}>
                                <Flex alignItems={'center'}>
                                    <Text mb={2} fontWeight="bold">
                                        URL parameters{" "}
                                        {/* <Text as="span" fontWeight="bold" color={'gray.600'} mr={1}>.</Text> */}
                                        <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                    </Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p={'5px'}>
                                                <Text >
                                                    Add parameters to the end of your website URL to track where your visitors are coming from.
                                                </Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" ml={2} mb={2} />
                                    </Tooltip>
                                </Flex>
                                <Input
                                    name="creative.url_tags"
                                    placeholder="key1=value1&key2=value2"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={formik.values.creative.url_tags}
                                    onChange={formik.handleChange}
                                />
                                <Flex mt={2}>
                                    <Button onClick={() => {
                                        setUrlParamModalOpen(true)
                                    }}
                                        variant="link"
                                        color='brand'>
                                        <Text fontSize={'12px'} >{'Build a URL parameter'}</Text>
                                    </Button>
                                </Flex>
                                {formik.touched.creative?.url_tags && formik.errors.creative?.url_tags && (
                                    <Text fontSize={"12px"} color="red.500">{formik.errors.creative?.url_tags}</Text>
                                )}
                            </Flex>
                        </Flex>
                    }

                    <Flex direction={'column'} gap={2} borderRadius="md" bg={background} p={4} mb={4}>
                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">CPA</Text>
                            <Input
                                name="cpa"
                                placeholder="Enter CPA"
                                bg="#fff"
                                size='sm'
                                borderRadius="md"
                                value={formik.values.cpa}
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                            />
                            {formik.touched.cpa && formik.errors.cpa && (
                                <Text fontSize={"12px"} color="red.500">{formik.errors.cpa}</Text>
                            )}
                        </Flex>
                    </Flex>

                    <Flex mb={4}>
                        <Button
                            size="sm"
                            colorScheme="brand"
                            isLoading={formik.isSubmitting}
                            type="submit"
                            isDisabled={!formik.isValid}
                        >
                            Save
                        </Button>
                    </Flex>
                </Box>

                <Box pos={'relative'} flex={0.6} px={4} borderRadius={'md'} direction={'column'} justifyContent={'space-between'} boxShadow="0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)">
                    <Flex py={2} gap={2} direction={'column'}>
                        <Flex gap={2}>
                            <Switch isChecked={isEnabled} colorScheme='brand' onChange={() => setIsEnabled(prevState => !prevState)} />
                            <Text fontWeight={'bold'} fontSize={'14px'}>Ad preview</Text>
                        </Flex>
                        <Divider />
                        {isEnabled &&
                            <AdPreviewCampaignSizes adCreative={adCreative} file={formik?.values} adsAccountData={adsAccountData} />
                        }
                    </Flex>

                    <Flex my={2} alignItems={'center'} position={'absolute'} bottom={0}>
                        <Text fontSize={'12px'} mr={2}>Ad rendering and interaction may vary based on device, format and other factors.</Text>
                        <Tooltip
                            borderRadius={5}
                            label={
                                <Box fontSize="12px" p="5px">
                                    <Text>
                                        Ads Manager previews are just examples and are not a substitute for reviewing Help Centre guidance and testing formats and devices to ensure that your ad delivers as intended.
                                    </Text>
                                </Box>
                            }
                            fontSize="md"
                        >
                            <InfoOutlineIcon pointerEvents="all" boxSize={3} />
                        </Tooltip>
                    </Flex>
                </Box>
            </Flex>

            <Modal isOpen={isUrlModalOpen} onClose={() => setUrlModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <BuildUrlParamsUpdate link={formik.values.creative.object_story_spec.link_data} onClose={() => setUrlModalOpen(false)} onUrlChange={handleUrlChange} />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Modal isOpen={isUrlParamModalOpen} onClose={() => setUrlParamModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <UrlParametersUpdate link={formik.values.creative} onClose={() => setUrlParamModalOpen(false)} onUrlChange={handleUrlParamChange} />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Modal isOpen={isEditMediaOpen} onClose={OnEditMediaClose} scrollBehavior={"inside"} size={"5xl"} isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Select media for placements</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Flex gap={2} justifyContent={'center'}>
                            {selectedMediaUrls
                                ?.sort((a, b) => {
                                    const order = ['square', 'vertical', 'horizontal'];
                                    return order.indexOf(a.placement) - order.indexOf(b.placement);
                                })
                                .map(({ placement, url, source, mediaType }) => {
                                    if (
                                        adCreative?.adset?.destination_type === 'APP' &&
                                        adCreative?.campaign?.objective === 'OUTCOME_SALES' &&
                                        placement !== 'square' &&
                                        placement !== 'vertical'
                                    ) return null;

                                    return(
                                    <Box
                                        key={placement}
                                        border="1px solid"
                                        borderColor={'gray.100'}
                                        borderRadius="md"
                                        p={2}
                                        width={'250px'}
                                        height={placement === 'square' ? '290px' : placement === 'vertical' ? '500px' : '230px'}
                                        display="flex"
                                        flexDirection="column"
                                        gap={2}
                                    >
                                        <Text fontWeight="bold" textTransform="capitalize">
                                            {placement}
                                        </Text>
                                        {source ? (
                                            <Box
                                                bg={'gray.50'}
                                                as="video"
                                                controls
                                                src={source}
                                                width={placement === 'square' ? '230px' : '230px'}
                                                height={placement === 'square' ? '200px' : placement === 'vertical' ? '450px' : '120px'}
                                                borderRadius="sm"
                                                objectFit={placement === 'square' ? 'contain' : placement === 'vertical' ? 'contain' : 'fill'}
                                            />
                                        ) : (
                                            <Image
                                                src={url}
                                                alt={placement}
                                                width={placement === 'square' ? '230px' : '230px'}
                                                height={placement === 'square' ? '200px' : placement === 'vertical' ? '450px' : '120px'}
                                                objectFit={placement === 'square' ? 'fill' : placement === 'vertical' ? 'cover' : 'fill'}
                                                borderRadius="sm"
                                            />
                                        )}
                                        <Flex>
                                            <Button
                                                size="sm"
                                                variant={'solid'}
                                                colorScheme={'gray'}
                                                leftIcon={<FaExchangeAlt />}
                                                onClick={() => handleReplaceImage(placement, mediaType)}
                                            >
                                                Replace
                                            </Button>
                                        </Flex>
                                    </Box>
                                )})}
                        </Flex>
                    </ModalBody>
                    <ModalFooter gap={2}>
                        <Button 
                            colorScheme="gray"
                            variant="solid"
                            size={'sm'} 
                            onClick={OnEditMediaClose}
                        >
                        Cancel
                        </Button>
                        <Button colorScheme="brand" size={'sm'} onClick={OnEditMediaClose}>
                            Save
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <MessageTemplateModal
                isOpen={isMessageModalOpen}
                onClose={onMessageModalClose}
                accountId={''}
                welcomeData={formik?.values?.creative?.asset_feed_spec?.additional_data?.page_welcome_message}
                onSave={(updatedData) => {
                    formik.setFieldValue('creative.asset_feed_spec.additional_data.page_welcome_message', updatedData);
                    onMessageModalClose();
                }}
            />

            {/* Drive Modal */}
            <DriveModal
                isDriveModalOpen={isDriveModalOpen}
                selectedAdAccounts={[{
                    id: adsAccountData?.id,
                    adsAccountId: adsAccountData?.account_id,
                    adsAccountName: adsAccountData?.name,
                    businessName: adsAccountData?.business?.name,
                    businessId: adsAccountData?.business?.id
                }]}
                onClose={() => setIsDriveModalOpen(false)}
                onSubmit={handleMediaSelect}
                uploadPurpose="update"
                mediaType={formik?.values?.creative?.asset_feed_spec?.ad_formats === 'SINGLE_VIDEO' ? 'video' : 'image'}
            />

            <ReplaceDriveModal
                isDriveModalOpen={isReplaceModalOpen}
                selectedAdAccounts={[{
                    id: adsAccountData?.id,
                    adsAccountId: adsAccountData?.account_id,
                    adsAccountName: adsAccountData?.name,
                    businessName: adsAccountData?.business?.name,
                    businessId: adsAccountData?.business?.id
                }]}
                onClose={() => {
                    OnReplaceModalClose();
                }}
                onSubmit={handleImageSelectedFromReplaceDrive}
                uploadPurpose="update"
                mediaType={formik?.values?.creative?.asset_feed_spec?.ad_formats === 'SINGLE_VIDEO' ? 'video' : 'image'}
            />
        </form>
    );
};

export default SizeAdUpdateForm;
